import { Outlet } from 'react-router-dom'
import AuthGuard from '../utils/route-quard/AuthGuard'
import { AuthProvider, useAuth } from '../context/AuthContext';
import { ToastProvider } from '../context/ToastContext';
import MainLayout from './MainLayout';
import { FileNavigatorProvider } from '../context/FileNavigator';
import { SettingsContextProvider } from '../context/SettingsContext';

const AuthLayout = () => {
 
    const { auth } = useAuth();
     
    /** 
     * Якщо немає авторизації, але токент існує - 
     * формуємо компонент "очікування перевірка авторизації"
     * Оскільки перевіряється валідність токена
     * 
     */
    const token = localStorage.getItem('authToken');
    const authMess = (token !== null) && (<span>Authorization...</span>);
    
        
    
     
    return (
        <AuthGuard> 
            {auth.isLogin &&  
            (<>
            <SettingsContextProvider>
                <FileNavigatorProvider>
                <MainLayout>
                    <Outlet />
                </MainLayout>
                </FileNavigatorProvider>
            </SettingsContextProvider>
            </>)}
        </AuthGuard>
    ) 
} 

export default AuthLayout;